export const bindMessage = {
  title: 'OCP Automatic Bind',
  message: 'Great news! OCP Binders can now be requested from Owners Edge! To submit a bind request please navigate to the Pricing summary of your OCP submission and click the Start Binder button near the bottom.'
}